export const FORM_KEYS = {
    QUALIFICATION: 'qualification',
    EDUCATION_DATA: 'educations'
};
export const EDUCATION_KEYS = {
    ID: 'id',
    COURSE: 'course_id',
    COURSE_TITLE: 'course_title',
    CERTIFICATE: 'certificate_id',
    CERTIFICATE_TITLE: 'certificate_title',
    COMBINED_TITLE: 'combined_title',
};